// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pricing-plan-list[data-v-224091c5]{align-content:stretch;display:grid;grid-gap:32px 48px;grid-template-columns:repeat(auto-fit,minmax(320px,368px));justify-content:center;margin:auto}.item[data-v-224091c5]{align-items:stretch;display:grid}", ""]);
// Exports
module.exports = exports;
